// src/services/gameService.js
import { useGameStore } from '../stores/gameStore';
import { SOCKET_EVENTS } from '../utils/constants';

/**
 * Checks if the socket is connected.
 * @param {object | null} socket - The socket instance.
 * @param {boolean} connected - Connection status from useSocket.
 * @returns {boolean} - True if connected, false otherwise.
 */
const checkSocket = (socket, connected) => {
	if (!socket || !connected) {
		console.error('Socket not connected');
		useGameStore.getState().setError('Could not connect to server');
		return false;
	}
	return true;
};

export const gameService = {
	createGame: (socket, connected, payload) => {
		if (!checkSocket(socket, connected)) return;
		socket.emit(SOCKET_EVENTS.CREATE_GAME, payload);
	},

	joinGame: (socket, connected, payload) => {
		if (!checkSocket(socket, connected)) return;
		socket.emit(SOCKET_EVENTS.JOIN_GAME, payload);
	},

	exitGame: (socket, connected, payload) => {
		if (!checkSocket(socket, connected) || !payload.gameId) return;

		socket.emit(SOCKET_EVENTS.EXIT_GAME, payload);
	},

	startGame: (socket, connected, payload) => {
		if (!checkSocket(socket, connected)) return;
		// Server should validate host status based on socket connection
		socket.emit(SOCKET_EVENTS.START_GAME, payload);
	},

	submitAnswer: (socket, connected, payload) => {
		if (!checkSocket(socket, connected)) return;
		socket.emit(SOCKET_EVENTS.SUBMIT_ANSWER, payload);
	},

	nextQuestion: (socket, connected, payload) => {
		if (!checkSocket(socket, connected)) return;
		// Server should validate host status
		socket.emit(SOCKET_EVENTS.NEXT_QUESTION, payload);
	},

	viewResults: (socket, connected, payload) => {
		if (!checkSocket(socket, connected)) return;
		// Server should validate host status
		socket.emit(SOCKET_EVENTS.VIEW_RESULTS, payload);
	},
};
